import React from "react";
import styled from "styled-components";
import { DistributionSegment } from "../../utils/campaignStatusTrackingUtils";

const BarTrack = styled.div<{ $single?: boolean }>`
	display: flex;
	gap: ${(p) => (p.$single ? "0" : "2px")};
	width: 100%;
	height: 10px;
	background: ${(p) => (p.$single ? "#fff" : "transparent")};
	border-radius: ${(p) => (p.$single ? "999px" : "5px")};
	overflow: hidden;
`;

const Segment = styled.div<{
	$color: string;
	$widthPercent: number;
	$isFirst: boolean;
	$isLast: boolean;
	$single?: boolean;
}>`
	height: 100%;
	width: ${(p) => p.$widthPercent}%;
	min-width: ${(p) => (p.$widthPercent > 0 ? "4px" : "0")};
	background: ${(p) => p.$color};
	border-radius: ${(p) => {
		if (p.$single) return "999px";
		const left = p.$isFirst ? "5px" : "0";
		const right = p.$isLast ? "5px" : "0";
		return `${left} ${right} ${right} ${left}`;
	}};
`;

interface StatusDistributionBarProps {
	segments: DistributionSegment[];
}

export const StatusDistributionBar: React.FC<StatusDistributionBarProps> = ({ segments }) => {
	if (segments.length === 0) return null;

	const isSingle = segments.length === 1;

	return (
		<BarTrack aria-hidden="true" $single={isSingle}>
			{segments.map((segment, index) => (
				<Segment
					key={segment.stage}
					$color={segment.color}
					$widthPercent={segment.widthPercent}
					$isFirst={index === 0}
					$isLast={index === segments.length - 1}
					$single={isSingle}
					title={`${segment.label}: ${segment.count}`}
				/>
			))}
		</BarTrack>
	);
};
